export const error = state => state.error
export const isLoading = state => state.isLoading
export const items = state => state.items
export const view = state => state.view
export const tableItems = state => {
  let returnItems = []
  state.items.forEach((item) => {
    let returnItem = {
      data: item,
      columns: [
        {
          field: 'name',
          value: item.name,
          type: 'string'
        },
        {
          field: 'code',
          value: item.code,
          type: 'string'
        }
      ]
    }
    returnItems.push(returnItem)
  })

  return returnItems
}
